import { ApiGetRequest } from '../../api';

export const state = {
  data: {
    title: 'Data Check Out',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Data Check Out',
        href: '/opc/check/out',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_booking_detail',
    sortDesc: true,
    doc_type_filter: '',
    status_filter: '1',
    date_filter: [],
    fields: [
      {
        key: 'doc_no',
        label: 'BOOK NO',
        thStyle: {
          width: '150px',
        },
      },
      {
        key: 'principle',
        label: 'Principle',
        thStyle: {
          width: '200px',
        },
      },
      {
        key: 'container',
        label: 'Container',
        thStyle: {
          width: '100px',
          textAlign: 'center',
        },
      },
      {
        key: 'kode_doc',
        label: 'Document',
        thStyle: {
          textAlign: 'center',
        },
      },
      {
        key: 'kode_payment',
        label: 'Payment',
        thStyle: {
          textAlign: 'center',
        },
      },
      {
        key: 'kode_crani',
        label: 'Crani',
        thStyle: {
          textAlign: 'center',
        },
      },
      {
        key: 'kode_survey',
        label: 'Survey',
        thStyle: {
          textAlign: 'center',
        },
      },
    ],
    detail: false,
    warning: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeCheckOut(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getWarningCheckOut({ commit }) {
    commit('changeCheckOut', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/check-out/warning`);
    commit('changeCheckOut', {
      warning: !result.error ? result.data.object : false,
      loading: false,
    });

    return !result.error ? (result.data.object ? result.data.object : 0) : 0;
  },

  async getListCheckOut({ commit, state }) {
    commit('changeCheckOut', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: data.id_principle ? data.id_principle : '',
      show_warning: data.show_warning ? 1 : 0,
    };

    let result = await ApiGetRequest(`opr/check-out`, params);
    commit('changeCheckOut', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },
};
